import React, { Component } from 'react'
import DisplayBySchemaCP from './DisplayBySchemaCP'
import Utils from '../../../common/Utils'


class DSFormCP extends Component {
  constructor (props) {
    super(props)
    /*
      props:
        formMeta type DisplaySchema
        initFormVals type {}
        validateForm type function (formVals, formMeta)
    */
    this.isEditable = true
    this.validateForm = (formVals, formMeta) => {return {formVals, formMeta, isFormValid:true}}
    this.onFormChange = (formVals, isFormValid) => {}
    if ('isEditable' in props) this.isEditable = props.isEditable
    if ('validateForm' in props) this.validateForm = props.validateForm
    if ('onFormChange' in props) this.onFormChange = props.onFormChange
    
    this.initState = {
      'formVals': Utils.clone(props.initFormVals),
      'formMeta': Utils.clone(props.formMeta),
      'isFormValid': true,
    }

    this.state = Utils.clone(this.initState)
  }


  // --- interface, all callable by parent --- //

  resetForm () {
    this.setState( Utils.clone(this.initState) )
  }

  onSubmit () {
    let nextState = this._validateForm()
    //return Utils.clone(this.state)
    return nextState
  }

  // --- x --- //

  _validateForm (_formVals = this.state.formVals) {
    let {formVals, formMeta, isFormValid} = this.validateForm( 
      Utils.clone(_formVals),
      Utils.clone(this.state.formMeta)
    )
    console.log('_validateForm', {formVals, formMeta, isFormValid})
    this.setState({
      'formVals': formVals,
      'formMeta': formMeta,
      'isFormValid': isFormValid,
    })
    return {formVals, formMeta, isFormValid}
  }

  _onChange (event, val, path) {
    var pathAr = Utils.pathTextToPathArray(path)
    pathAr.shift() // why this?
    let formVals = Utils.clone(this.state.formVals)
    Utils.setByPathArray(formVals, pathAr, val)
    let isFormValid = this.state.isFormValid
    if (!this.state.isFormValid) {
      let nextState = this._validateForm(formVals)
      isFormValid = nextState.isFormValid
    } else {
      this.setState({
        'formVals': formVals,
      })
    }
    this.onFormChange(formVals, isFormValid)
  }

  render () {
    return (
      <DisplayBySchemaCP objPath='' 
        isEditable={this.isEditable} 
        value={this.state.formVals} 
        meta={this.state.formMeta} 
        onChange={(event, val, path) => this._onChange(event, val, path)} 
        omitRootContain={true} 
      />
    )
  }
}

export default DSFormCP
